import { registerApi as api } from '../../api';

export const fetchleaveOpeningBalanceData = async (current_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const response = await api.get(`/get_leave_opening_balance/${current_month}`, {
      params: {
        client_id: client_ID
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const updateleaveOpeningBalance = async (id, LeaveData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_leave_opening_balance/${id}`, LeaveData, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }

    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}




export const deleteLeaveOpeningBalance = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_leave_opening_balance/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}



// export const LeaveOpeningBalanceDataUpload = async (LeaveDataInput) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/upload_leave_opening_balance', LeaveDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params : {
//         'selectedClientID' : selectedClientID
//       }
//     });    
//     return {
//       data: response.data,
//       status: response.status,
//     };
//   } catch (error) {
//     throw error.response ? error.response.data : error.message;
//   }
// };



export const LeaveOpeningBalanceDataUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_leave_opening_balance', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};




export const multiDeleteleaveOpeningBalance = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_leave_opening_balance', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

